import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import posthog, { posthogEnabled } from './analytics/posthog';
import { installErrorMonitoring } from './analytics/errorMonitoring';
import { PostHogProvider, PostHogErrorBoundary } from '@posthog/react';

installErrorMonitoring();

const root = ReactDOM.createRoot(document.getElementById('root'));

const app = (
  <React.StrictMode>
    <PostHogErrorBoundary>
      <App />
    </PostHogErrorBoundary>
  </React.StrictMode>
);

root.render(
  posthogEnabled ? (
    <PostHogProvider client={posthog}>{app}</PostHogProvider>
  ) : (
    app
  )
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
